import { render, staticRenderFns } from "./PartnershipDetailsModal.vue?vue&type=template&id=02a7f900&"
import script from "./PartnershipDetailsModal.vue?vue&type=script&lang=js&"
export * from "./PartnershipDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports